import { ISummaryTranslation } from "../../model/translations/SummaryTranslation";
import { parseBooleanValue } from "../../../util";

const SummaryTranslationParamMapper = (item: ISummaryTranslation) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default SummaryTranslationParamMapper;
